import type { Research } from '@/api/types';

/** The report section that leads the strip as its own tile instead of closing the report. */
export const RECOMMENDATION_KEY = 'recommendation';

export function recommendationOf(research: Research): string | null {
  const section = research.report.find((s) => s.key === RECOMMENDATION_KEY);
  return section?.markdown ? withoutLeadTitle(section.markdown, section.title) : null;
}

const skipPunctuation = (text: string) => (text.startsWith('.') || text.startsWith(':') ? text.slice(1) : text);

/**
 * Models often open a section by repeating its title in bold ("**Market opportunity.** …"); the heading already says it.
 * Matched by plain string comparison, not a RegExp built from the title, so no character in a title can change the match.
 */
export function withoutLeadTitle(markdown: string, title: string): string {
  const start = markdown.trimStart();
  if (!start.startsWith('**')) return markdown;
  const afterOpen = start.slice(2);
  if (afterOpen.slice(0, title.length).toLowerCase() !== title.toLowerCase()) return markdown;
  const afterTitle = skipPunctuation(afterOpen.slice(title.length));
  if (!afterTitle.startsWith('**')) return markdown;
  return skipPunctuation(afterTitle.slice(2)).trimStart();
}
